import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks on the Building Your Favorites List tutorial on the Help page
 * Event: dental_portal:help:favorites_tutorial_clicked
 */
export function fireHelpFavoritesTutorialClicked(): void {
  PosthogService.getInstance().track('dental_portal:help:favorites_tutorial_clicked');
}
